import React, {Component} from "react";

export default class KeyVal extends Component {

    componentDidMount() {
    }

    render() {
        return (
            <div className="d-flex flex-row justify-content-between">
                <div
                    className="d-flex  w-50 flex-column justify-content-center align-items-start grey-text">
                    <span>{this.props.name}</span></div>
                <div className="d-flex  justify-content-end align-items-center text-right">
                    {
                        this.props.link ? <a className="blue-text under-line" href={this.props.link}>{this.props.value}</a> : (<span className={this.props.green ? 'green-text' : ''}>{this.props.value}</span>)
                    }
                    </div>
            </div>
        );
    }
}
